import { FC, ReactElement } from 'react';

import { MarketingAction } from '../../entities/MarketingAction/MarketingAction';
import { ProductPriceInterface } from '../../entities/Price/Price';
import { useTrans } from '../../hooks';
import { DiscountLabel, MarketingActionLabel } from '..';

import './ProductLabels.scss';

interface ProductLabels {
    isNew: boolean;
    isInStock: boolean;
    price: ProductPriceInterface;
    marketingAction?: MarketingAction;
    className?: string;
}

export const ProductLabels: FC<ProductLabels> = ({
    isNew,
    isInStock,
    price,
    marketingAction,
    className = '',
}): ReactElement => {
    const trans = useTrans();

    // @TODO: Remove this when data is available
    const showLabel = false;

    return (
        <div className={`product-labels ${className}`}>
            {showLabel && (
                // @TODO: Check if product is a bestseller (L5W-389)
                <p className="product-labels__label product-labels__label--is-outlined product-labels__label--is-bestseller">
                    {trans('compositions.productLabels.bestseller')}
                </p>
            )}

            {showLabel && (
                // @TODO: Check if product is only online available (L5W-389 / L5W-871)
                <p className="product-labels__label product-labels__label--is-online-only">
                    {trans('compositions.productLabels.onlyOnline')}
                </p>
            )}

            {marketingAction && (
                <MarketingActionLabel
                    marketingAction={marketingAction}
                    className="product-labels__label"
                />
            )}

            {price.discount && (
                <DiscountLabel price={price} />
            )}

            {isNew && (
                <p className="product-labels__label product-labels__label--is-outlined">
                    {trans('compositions.productLabels.isNew')}
                </p>
            )}

            {!isInStock && (
                <p className="product-labels__label product-labels__label--is-outlined">
                    {trans('compositions.productLabels.soldOut')}
                </p>
            )}
        </div>
    );
};
